import toast from 'react-hot-toast';
import { useSWRConfig } from 'swr';
import { captureException } from '@sentry/react';

import { Dialog } from '../../../components/dialog/Dialog';
import { createSupplier, SUPPLIERS_SWR_KEY } from '../models';
import type { CreateSupplierResponse } from '../endpoints/CreateSupplierEndpoint.types';
import { getDisplayError } from '../../../utils/get-display-error';
import { trackEvent } from '../../../utils/track-event';
import { CreateSupplierForm } from './CreateSupplierForm';

export interface ICreateSupplierDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreated: (created: CreateSupplierResponse) => void;
  initialName?: string;
}

export const CreateSupplierDialog: React.FC<ICreateSupplierDialogProps> = (props) => {
  const { isOpen, onClose, onCreated, initialName } = props;
  const { mutate } = useSWRConfig();

  return (
    // Not dismissable: this form is long enough that a stray outside click would
    // silently discard everything. Cancel is the way out.
    <Dialog isOpen={isOpen} onClose={onClose} title="Nieuwe vervoerder" isDismissable={false}>
      <CreateSupplierForm
        initialName={initialName}
        onCancel={onClose}
        onSubmit={async (inputData) => {
          try {
            const result = await createSupplier(inputData);
            trackEvent('supplier_created', {
              supplier_id: result.id,
              country: inputData.country,
            });
            // The combobox's list cache is now stale — reopening it should show the new carrier.
            await mutate((key) => Array.isArray(key) && key[0] === SUPPLIERS_SWR_KEY);
            onCreated(result);
            toast.success('Vervoerder aangemaakt');
          } catch (err: any) {
            captureException(err);
            toast.error('Kon vervoerder niet aanmaken: ' + getDisplayError(err));
          }
        }}
      />
    </Dialog>
  );
};
